import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_CURRENT_USER,
  GET_CURRENT_USER_FAIL,
  GET_CURRENT_USER_SUCCESS,
  GET_SETTINGS,
  GET_SETTINGS_FAIL,
  GET_SETTINGS_SUCCESS,
  GET_CURRENT_USER_WALLET_ADDRESS,
  REQUEST_FOR_VERIFICATION,
  REQUEST_FOR_VERIFICATION_FAIL,
  REQUEST_FOR_VERIFICATION_SUCCESS,
  COLLECTION_REQ_FOR_VERIFICATION,
  COLLECTION_REQ_FOR_VERIFICATION_SUCCESS,
  COLLECTION_REQ_FOR_VERIFICATION_FAIL,
  FORGET_PASSWORD,
  FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD_SUCCESSFUL,
  VERIFY_OTP,
  VERIFY_OTP_FAILED,
  VERIFY_OTP_SUCCESSFUL,
  PASSWORD_RESET,
  PASSWORD_RESET_FAILED,
  PASSWORD_RESET_SUCCESSFUL,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_AGAIN_REQUEST,
  GET_PARTIULAR_USER,
  GET_PARTIULAR_USER_SUCCESSFUL,
  GET_PARTIULAR_USER_FAILED,
  POLYGON_SIGN_IN,
  POLYGON_SIGN_IN_FAILED,
  POLYGON_SIGN_IN_SUCCESSFUL,
  POLYGON_AUTH_UPDATE,
  POLYGON_AUTH_UPDATE_FAILED,
  POLYGON_AUTH_UPDATE_SUCCESSFUL
} from "./actionTypes";

export const loginUser = (user, callback) => {
  return {
    type: LOGIN_USER,
    payload: { user, callback },
  };
};
export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

// Logout User

export const logoutUser = (navigate) => {
  return {
    type: LOGOUT_USER,
    payload: { navigate },
  };
};
export const logoutUserSuccess = (data) => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: data,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

//  Current User

export const getCurrentUser = () => ({
  type: GET_CURRENT_USER,
});
export const getCurrentUserWalletAddress = (address) => ({
  type: GET_CURRENT_USER_WALLET_ADDRESS,
  payload: address,
});
export const getCurrentUserSuccess = (user) => ({
  type: GET_CURRENT_USER_SUCCESS,
  payload: user,
});
export const getCurrentUserFail = (error) => ({
  type: GET_CURRENT_USER_FAIL,
  payload: error,
});

export const getSettings = () => ({
  type: GET_SETTINGS,
});
export const getSettingsSuccess = (setting) => ({
  type: GET_SETTINGS_SUCCESS,
  payload: setting,
});
export const getSettingsFail = () => ({
  type: GET_SETTINGS_FAIL,
});

//request for verficatoin
export const rquestForVerfication = (callback) => ({
  type: REQUEST_FOR_VERIFICATION,
  payload: callback,
});
export const rquestForVerficationFail = (address) => ({
  type: REQUEST_FOR_VERIFICATION_FAIL,
  payload: address,
});
export const rquestForVerficationSuccess = (user) => ({
  type: REQUEST_FOR_VERIFICATION_SUCCESS,
  payload: user,
});

//request for verficatoin
export const verificationCollectionRequest = (data, callback) => ({
  type: COLLECTION_REQ_FOR_VERIFICATION,
  payload: { data, callback },
});
export const verificationCollectionRequestFail = (address) => ({
  type: COLLECTION_REQ_FOR_VERIFICATION_FAIL,
  payload: address,
});
export const verificationCollectionRequestSuccess = (user) => ({
  type: COLLECTION_REQ_FOR_VERIFICATION_SUCCESS,
  payload: user,
});

//  forget Password

export const forgetPassword = (user, callback) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, callback },
  };
};
export const forgetPasswordSuccessful = (user) => {
  return {
    type: FORGET_PASSWORD_SUCCESSFUL,
    payload: user,
  };
};
export const forgetPasswordFailed = (user) => {
  return {
    type: FORGET_PASSWORD_FAILED,
    payload: user,
  };
};

//  Reset Password

export const resetPassword = (user, callback) => {
  return {
    type: PASSWORD_RESET,
    payload: { user, callback },
  };
};
export const resetPasswordSuccessful = (user) => {
  return {
    type: PASSWORD_RESET_SUCCESSFUL,
    payload: user,
  };
};
export const resetPasswordFailed = (user) => {
  return {
    type: PASSWORD_RESET_FAILED,
    payload: user,
  };
};

//  Verify Otp

export const VerifyUserOtp = (user, callback) => {
  return {
    type: VERIFY_OTP,
    payload: { user, callback },
  };
};
export const VerifyUserOtpSuccessful = (user) => {
  return {
    type: VERIFY_OTP_SUCCESSFUL,
    payload: user,
  };
};
export const VerifyUserOtpFailed = (user) => {
  return {
    type: VERIFY_OTP_FAILED,
    payload: user,
  };
};

//email verify
export const verifyEmail = (token, callback) => ({
  type: VERIFY_EMAIL_REQUEST,
  payload: { token, callback },
});
export const verifyEmailAgain = (email, callback) => ({
  type: VERIFY_EMAIL_AGAIN_REQUEST,
  payload: { email, callback },
});
export const verifyEmailSuccessAgain = () => ({
  type: 'AUTH_SUCCESS',
});

//gte particular user
//email verify
export const getParticularUser = (id, callback) => ({
  type: GET_PARTIULAR_USER,
  payload: { id, callback },
});
export const getParticularUserFailed = (error) => ({
  type: GET_PARTIULAR_USER_FAILED,
  payload: error,
});
export const getParticularUserSuccess = (user) => ({
  type: GET_PARTIULAR_USER_SUCCESSFUL,
  payload:user,
});

//  polygon id login 
export const polygonSignIn = (id, callback) => ({
  type: POLYGON_SIGN_IN,
  payload: { id, callback },
});
export const polygonSignInFailed = (error) => ({
  type: POLYGON_SIGN_IN_FAILED,
  payload: error,
});
export const polygonSignInSuccess = (user) => ({
  type: POLYGON_SIGN_IN_SUCCESSFUL,
  payload:user,
});

// polygon Auth update 


export const polygonAuthUpdate = (id, callback) => ({
  type: POLYGON_AUTH_UPDATE,
  payload: { id, callback },
});
export const polygonAuthUpdateFailed = (error) => ({
  type: POLYGON_AUTH_UPDATE_FAILED,
  payload: error,
});
export const polygonAuthUpdateSuccess = (user) => ({
  type: POLYGON_AUTH_UPDATE_SUCCESSFUL,
  payload:user,
});

